<template>
    <div v-if="mostrar" style="overflow: auto" class="modal-mask" @click="$emit('fechar')">
        <div class="jm" style="height: min-content; width: 50rem; padding: 2rem;" @click.stop>
            <div style="text-align: center; width: 100%;">
                <div>
                    <h2>Deseja excluir o programa {{ programaNome }}?</h2>
                </div>
                <br>
                <div class="modal-footer">
                    <button type="button" class="button" @click="$emit('confirmar')">Confirmar</button>
                    <button type="button" class="button acao-secundaria" @click="$emit('fechar')"
                        style="margin-left: 0.5rem;">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalExcluirPrograma",
    props: {
        mostrar: { type: Boolean, default: false },
        programaNome: { type: String, default: "" },
    },
    emits: ["fechar", "confirmar"],
};
</script>
